import axios from "axios";
import { getToken } from "../../auth/authService";

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    Authorization: `Bearer ${getToken()}`,
    "Content-Type": "application/json",
  },
});

export const createSessionLink = async (payload) => {
  try {
    const response = await api.post("/admin/session-links", payload);
    return { status: response.status, data: response.data };
  } catch (err) {
    return {
      status: err.response?.status || 500,
      data: null,
      message: err.response?.data?.message || err.message || "Failed to create link",
    };
  }
};

export const getAllSessionLinks = async () => {
  try {
    const response = await api.get("/admin/session-links");
    return { status: response.status, data: response.data };
  } catch (err) {
    return {
      status: err.response?.status || 500,
      data: [],
      message: err.response?.data?.message || err.message || "Failed to fetch links",
    };
  }
};

export const toggleSessionLink = async (id) => {
  try {
    const response = await api.patch(`/admin/session-links/${id}/toggle`);
    return { status: response.status, data: response.data };
  } catch (err) {
    return {
      status: err.response?.status || 500,
      data: null,
      message: err.response?.data?.message || err.message || "Failed to toggle link",
    };
  }
};

export const deleteSessionLink = async (id) => {
  try {
    const response = await api.delete(`/admin/session-links/${id}`);
    return { status: response.status };
  } catch (err) {
    return {
      status: err.response?.status || 500,
      message: err.response?.data?.message || err.message || "Failed to delete link",
    };
  }
};

export const getLinkRegistrations = async (id) => {
  try {
    const response = await api.get(`/admin/session-links/${id}/registrations`);
    return { status: response.status, data: response.data };
  } catch (err) {
    return {
      status: err.response?.status || 500,
      data: [],
      message: err.response?.data?.message || err.message || "Failed to fetch registrations",
    };
  }
};
